import React from 'react';
import { Link } from 'react-router-dom';
import './HomePage.css';

const HomePage: React.FC = () => {
  return (
    <div className="homepage">
      {/* Hero Section - Layered with Real Photo + Animated Fog */}
      <section className="hero-layered">
        {/* Background: Real Player Photo - Desktop */}
        <div className="hero-player-bg hero-player-desktop"></div>
        
        {/* Background: Cropped Player Photo - Mobile */}
        <div className="hero-player-bg hero-player-mobile"></div>
        
        {/* Mobile Hero Background Image */}
        <img 
          src="/images/mobile-hero-color.jpg" 
          alt="" 
          className="mobile-hero-bg"
          style={{display: 'none'}}
        />
        
        {/* Animated Fog Overlays */}
        <div className="hero-fog-layer fog-1"></div>
        <div className="hero-fog-layer fog-2"></div>
        
        {/* Gradient Overlay for depth */}
        <div className="hero-gradient-overlay"></div>
        
        {/* Content Layer */}
        <div className="hero-content-layer">
          <div className="hero-logo-section">
            <img src="/images/logo-clean.png" alt="Xcelerate Logo" className="hero-logo-img" />
          </div>
          <div className="hero-text-section">
            <h1 className="hero-main-title">XCELERATE</h1>
            <p className="hero-main-tagline">ACCELERATE TO EXCELLENCE</p>
            <p className="hero-location">Omaha Metro • Limited Roster Spots</p>
          </div>
          <div className="hero-player-container">
            <img src="/images/player-cropped.png" alt="Player" className="hero-player-mobile-img" />
          </div>
          <Link to="/assessment" className="hero-cta-button">BEGIN ASSESSMENT</Link>
        </div>
      </section>

      {/* The Program - Black Leather Background */}
      <section className="program-premium">
        <div className="container">
          <h2 className="section-title-gold">THE PROGRAM</h2>
          <div className="section-divider-gold"></div>
          <div className="program-intro-premium">
            <p>Xcelerate is not a traditional training service—it's a year-round mentorship program. We build long-term relationships with a small, select group of committed athletes. You don't book individual sessions; you join the program and train directly with Coach Mesa and his coaches throughout the entire off-season. Together we set clear, personalized goals, then use our IX test, video analysis, and detailed assessments to pinpoint exactly where you are and build the fastest path to where you want to be.</p>
          </div>
          <div className="program-grid-premium">
            <div className="program-card-premium">
              <div className="card-accent-gold"></div>
              <h3>CUSTOM PROGRESS TRACKING</h3>
              <p>Baseline IX score & skill assessment, with measured gains tracked throughout the entire off-season</p>
            </div>
            <div className="program-card-premium">
              <div className="card-accent-gold"></div>
              <h3>100% PERSONALIZED PLANS</h3>
              <p>Built from YOUR film, body type, and goals—not a one-size-fits-all template</p>
            </div>
            <div className="program-card-premium">
              <div className="card-accent-gold"></div>
              <h3>ELITE FILM STUDY</h3>
              <p>Your HS clips + College/Pro examples to master reads, technique, and decision-making</p>
            </div>
            <div className="program-card-premium">
              <div className="card-accent-gold"></div>
              <h3>POSITION-SPECIFIC TRAINING</h3>
              <p>Footwork, hand placement, pad level, run/pass schemes—everything your position demands</p>
            </div>
            <div className="program-card-premium">
              <div className="card-accent-gold"></div>
              <h3>FULL OFF-SEASON ROADMAP</h3>
              <p>Weekly check-ins & milestones from NOW through summer camp—we're with you the whole way</p>
            </div>
            <div className="program-card-premium">
              <div className="card-accent-gold"></div>
              <h3>RELATIONSHIP-DRIVEN</h3>
              <p>This is mentorship, not transactions. We build trust, accountability, and lasting growth</p>
            </div>
          </div>
        </div>
      </section>

      {/* Coach Credentials - White Leather Background */}
      <section className="credentials-premium">
        <div className="container">
          <h2 className="section-title-dark">ELITE COACHING PEDIGREE</h2>
          <div className="section-divider-dark"></div>
          <div className="credentials-content-premium">
            <p className="credentials-highlight-premium">Trained Under Legendary Coaches</p>
            <div className="credentials-list-premium">
              <p className="credentials-category">Head Coaches / Legends</p>
              <p>Bill Belichick (Patriots Legend, 6x SB Champ) • Tom Osborne (Nebraska Icon, 3x National Champ) • Matt Rhule (Nebraska HC) • Chris Klieman (K-State HC) • PJ Fleck (Minnesota HC)</p>
              
              <p className="credentials-category">Offensive Coordinators / Position Coaches</p>
              <p>Dana Holgorsen (Nebraska OC) • Greg Harbaugh Jr. (Minnesota OC/QBs) • Bill Bedenbaugh (Oklahoma OL) • Cooper Bassett (Oklahoma State OL) • Marcus Satterfield (Nebraska TE) • Joe Jon Finley (Oklahoma TE) • EJ Barthel (Nebraska RB)</p>
              
              <p className="credentials-category">Defensive / Specialist</p>
              <p>Van Malone (K-State Asst HC/CBs) • Rob Dvoracek (Nebraska LB Coach)</p>
              
              <p className="credentials-footer-premium">...and many more</p>
            </div>
          </div>
        </div>
      </section>

      {/* Who We Train - Black Leather Background */}
      <section className="who-we-train-premium">
        <div className="container">
          <h2 className="section-title-gold">WHO WE TRAIN</h2>
          <div className="section-divider-gold"></div>
          <div className="who-grid-premium">
            <div className="who-card-premium">
              <h3>HIGH SCHOOL ATHLETES</h3>
              <p>Serious players who want to dominate their position and earn college looks</p>
            </div>
            <div className="who-card-premium">
              <h3>COLLEGE PREP</h3>
              <p>Athletes preparing for the next level with elite technique and IX mastery</p>
            </div>
            <div className="who-card-premium">
              <h3>COMMITTED MINDSET</h3>
              <p>Players ready to invest in a full off-season mentorship program</p>
            </div>
          </div>
        </div>
      </section>

      {/* Final CTA - Fog Overlay */}
      <section className="cta-final-premium">
        <div className="container">
          <h2>READY TO XCELERATE?</h2>
          <p>Limited roster spots available. Start your assessment today.</p>
          <Link to="/assessment" className="cta-button-final">BEGIN ASSESSMENT</Link>
        </div>
      </section>
    </div>
  );
};

export default HomePage;

